import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { JQ_TOKEN } from '../../core/jquery.service';
import { IntercomService } from '../../shared/intercom.service';
import { MixpanelService } from '../../shared/mixpanel.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [IntercomService]
})
export class LoginComponent implements OnInit, OnDestroy {
  message: any;
  // store the URL so we can redirect after logging in
  returnUrl: string;

  constructor(
    private auth: AuthService,
    private intercom: IntercomService,
    private mixpanel: MixpanelService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(JQ_TOKEN) private $: any
  ) {}

  ngOnInit() {
    // get return url from route parameters or default to '/locations'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/locations';
    console.log(this.returnUrl);

    return this.intercom.initIntercomNonLoggedIn({
      current_view: 'Login Page',
      location_name: 'N.A.',
      room_name: 'N.A.'
    });
  }

  ngOnDestroy() {
    this.intercom.shutDownIntercom();
  }

  async onSignIn(form: NgForm) {
    this.$('#loading-modal').modal();
    try {
      const email = form.value.email;
      const password = form.value.password;
      await this.auth.login(email, password);
      this.mixpanel.identify();
      // tslint:disable-next-line: max-line-length
      this.mixpanel.track('Log in', {
        $email: email
      });
    } catch (error) {
      this.$('#loading-modal').modal('hide');
      console.error(`Error with user login: ${error}`);
      this.message = `Unable to complete login, try again or contact admin`;
    }

    // only track successful logins

    if (this.auth.isClientAdmin()) {
      this.router.navigate(['/users']);
    }
    if (this.auth.isAdmin() || this.auth.isUser()) {
      this.router.navigateByUrl(this.returnUrl);
    }
    this.$('#loading-modal').modal('hide');
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/login/login.component.ts